<nav id="NavBar"
     class="navbar nav navbar-expand-custom navbar-inverse fixed-top"
     role="navigation"
     style="padding-left:0;"
     *ngIf="!hideBar">
  <div id="fadeNav"></div>
  <!-- SideNav for mobile view -->
  <div class="sidenav" id="globalSideNav">
    <a href="javascript:void(0)" class="closebtn" (click)="closeGlobalNav()">&times;</a>
    <div class="container" id="navOptions" style="padding-left:0px;">
      <ul style="padding-left:0px;">
        <li *ngFor="let category of moduleCategoriesMobile;let mobileIndex = index ">
          <a *ngIf="category.CategoryName === 'Office Tools'" class="nav-link" href="/Office/Index">Office Tools</a>
          <a *ngIf="category.ModuleCount > 0 && category.CategoryName !== 'Office Tools'" role="button" (click)="closeMenusSection(mobileIndex,null)"
             class="dropdown sections-header">
            {{category.CategoryName}}
            <span class="badge badge-pill badge-danger" *ngIf="category.CategoryName == 'Approval' && unapprovedRequestCount > 0">{{unapprovedRequestCount}}</span>
            <span class="badge badge-pill badge-danger" *ngIf="category.CategoryName === 'Approval' && unapprovedRequestCount == 0 && flagsExist"><span class="oi oi-flag"></span></span>
            <span class="badge badge-pill badge-danger" *ngIf='category.CategoryName == "Field Tools" && fieldToolsCount > 0'>{{fieldToolsCount}}</span>
            <span class="badge badge-pill badge-danger" *ngIf='showCCTransactionCount() && category.CategoryName == "Employee Tools" && unReconciledLinesCount > 0'>{{unReconciledLinesCount}}</span>
          </a>
          <ul class="resp-left" style="left:0;right:auto" [hidden]="!menu[mobileIndex]" *ngIf="category.ModuleCount > 0">
            <li *ngFor="let categoryModule of category.Modules;let moduleIndex = index">
              <ng-container *ngIf="moduleIndex < category.Modules.length - 1 && (moduleIndex == 0 || categoryModule.ModuleSubCatgName != category.Modules[moduleIndex-1].ModuleSubCatgName)">
                <span class="dropdown-header nav-dropdown-header">{{category.Modules[moduleIndex].ModuleSubCatgName}}</span>
              </ng-container>
              <a class="dropdown-item" *ngIf="categoryModule.ModuleShowInNav && categoryModule.IsNewAngular && categoryModule.ModulePrettyShortName == 'Work Order Dashboard' || categoryModule.ModulePrettyShortName == 'Service Manager Dashboard'"
                 href="{{categoryModule.ModuleActionName_Route}}" style="cursor: pointer;" [fragment]="categoryModule.ModuleActionName_Fragment" [target]="categoryModule.ModuleOpenNewWindow ? '_blank' : '_self'">
                {{categoryModule.ModulePrettyShortName}}
              </a>
              <a class="dropdown-item" *ngIf="categoryModule.ModuleShowInNav && categoryModule.IsNewAngular && categoryModule.ModuleName != 'TrimblePay' &&
categoryModule.ModuleName != 'ServiceHub' && categoryModule.ModuleName != 'ClockInKiosk' && categoryModule.ModulePrettyShortName != 'Work Order Dashboard' && categoryModule.ModulePrettyShortName != 'Service Manager Dashboard'"
                 routerLink="{{categoryModule.ModuleActionName_Route}}" [fragment]="categoryModule.ModuleActionName_Fragment" [target]="categoryModule.ModuleOpenNewWindow ? '_blank' : '_self'">
                {{categoryModule.ModulePrettyShortName}}
                <span class="badge badge-pill"
                      [ngClass]="approvalCounts[categoryModule.ApprovalType] == 0 ? 'badge-success' : 'badge-danger'"
                      *ngIf="categoryModule.ApprovalType && categoryModule.ApprovalType != 'IssueTracker' && categoryModule.ApprovalType != 'ExpenseSubmit' && approvalCounts[categoryModule.ApprovalType] >= 0">{{approvalCounts[categoryModule.ApprovalType]}}</span>
                <span class="badge badge-pill badge-danger" *ngIf="categoryModule.ApprovalType && approvalCounts[categoryModule.ApprovalType] < 0"><span class="oi oi-flag"></span></span>

                <span class="badge badge-pill"
                      [ngClass]="fieldToolsCount == 0 ? 'badge-success' : 'badge-danger'"
                      *ngIf="categoryModule.ApprovalType == 'IssueTracker' && fieldToolsCount != null">{{fieldToolsCount}}</span>

                <span class="badge badge-pill"
                      [ngClass]="unReconciledLinesCount == 0 ? 'badge-success' : 'badge-danger'"
                      *ngIf="showCCTransactionCount() && categoryModule.ApprovalType == 'ExpenseSubmit' && unReconciledLinesCount != null">{{unReconciledLinesCount}}</span>

                <span class="badge badge-pill badge-danger" *ngIf="categoryModule.ModuleActionName == userAccess && isOver()"><span class="oi oi-flag"></span></span>
              </a>
              <a class="dropdown-item" *ngIf="categoryModule.ModuleShowInNav && categoryModule.IsNewAngular && categoryModule.ModuleName == 'ClockInKiosk'" [href]="" [target]="categoryModule.ModuleOpenNewWindow ? '_blank' : '_self'" (click)="onKioskClicked($event, categoryModule.ModuleActionName)">
                {{categoryModule.ModulePrettyShortName}}
              </a>
              <a class="dropdown-item pointer" *ngIf="categoryModule.ModuleName === 'TrimblePay'" (click)="openPayLink()">
                Trimble Pay
              </a>
              <a class="dropdown-item pointer" *ngIf="categoryModule.ModuleName === 'ServiceHub'" (click)="openServiceHubLink()">
                Service Hub
              </a>
              <ng-container *ngIf="moduleIndex != category.Modules.length - 1 && categoryModule.ModuleSubCatgName != category.Modules[moduleIndex + 1].ModuleSubCatgName">
                <span class="dropdown-divider"></span>
              </ng-container>
            </li>
          </ul>
        </li>
        <li *ngIf="hotlistItems.length > 0">
          <a class="dropdown sections-header"
             href="#"
             (click)="closeMenusSection(null,'h')"
             role="button">
            Hotlist Items
          </a>
          <ul class="resp-left" [hidden]="!hotlistMenu">
            <li *ngFor="let hotlistItem of hotlistItems; let index = index">
              <a *ngIf="hotlistItem.IsNewAngular && hotlistItem.ModuleName != 'ClockInKiosk' && hotlistItem.ModuleName != 'ServiceHub'" routerLink="{{hotlistItem.ModuleActionName_Route}}" [fragment]="hotlistItem.ModuleActionName_Fragment" [target]="hotlistItem.ModuleOpenNewWindow ? '_blank' : '_self'">{{hotlistItem.ModulePrettyShortName}}</a>
              <a *ngIf="!hotlistItem.IsNewAngular" href="{{hotlistItem.ModuleActionName}}" [target]="hotlistItem.ModuleOpenNewWindow ? '_blank' : null">{{hotlistItem.ModulePrettyShortName}}</a>
              <a *ngIf="hotlistItem.IsNewAngular && hotlistItem.ModuleName == 'ClockInKiosk'" [href]="" [target]="hotlistItem.ModuleOpenNewWindow ? '_blank' : '_self'" (click)="onKioskClicked($event,hotlistItem.ModuleActionName)">
                {{hotlistItem.ModulePrettyShortName}}
              </a>
              <a *ngIf="hotlistItem.ModuleName === 'ServiceHub'" [href]="" [target]="hotlistItem.ModuleOpenNewWindow ? '_blank' : '_self'" (click)="openServiceHubLink()">
                {{hotlistItem.ModulePrettyShortName}}
              </a>
            </li>
          </ul>
        </li>
        <li>
          <a href="#"
             (click)="closeMenusSection(null,'n')"
             class="sections-header dropdown">
            <span class="oi oi-person" style="margin-right: 5px;"></span>
            <span>{{employeeName}}</span>
          </a>
          <ul class="resp-left" [hidden]="!userNameMenu">
            <li *ngIf="helpLink() !== null && helpLink() !== ''"><a target="_blank" [href]="helpLink()">Help</a></li>
            <li><a href="mailto:{{feedbackEmail()}}?subject=Employee Portal Feedback">Feedback?</a></li>
            <li *ngIf="showPaperless()"><a href="#" (click)="paperLessModal()">Manage Paperless Settings</a></li>
            <li *ngIf="loginMode() == 'viewpoint' || loginMode() == 'viewpointID'"><a class="dropdown-item" style="cursor:pointer" [routerLink]="'/account/changeaccountpassword'" [queryParams]="{}">Change Password</a></li>
            <li *ngIf="suggestionUrl !== null"><a [href]="suggestionUrl" target="_blank">Suggestion Box <img src="/Cache/images/Discussions.png" style="margin-left: 5px;" /></a></li>
            <li *ngIf="mobileInitUrl !== null"><a [href]="this.mobileInitUrl  | dOMSafe:'url'">Initialize Mobile App</a></li>
            <app-navbar-clock-in *ngIf="navBarClockInEnabled()"></app-navbar-clock-in>

            <li class="dropdown-divider"></li>
            <li><a style="cursor: pointer" (click)="logout()">Logout</a></li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <div class="container-fluid" style="flex-wrap: nowrap; padding-left:0; padding-right:0;">
    <a class="navbar-brand mr-auto" routerLink="/" style="display: inline-flex">
      <img id="logo"
           *ngIf="logoUrl()"
           style="display: inline;"
           [style.max-width.px]="logoUrlBroken() ? 276 : null"
           [src]="logoUrl()"
           alt=""
           (error)="companyLogoError()" />
      <span class="navbar-brand-text"
            style="font-size: 15px;margin-top: 5px; margin-left: 10px;"
            *ngIf="portalName()">
        {{portalName()}}
      </span>
    </a>
    <div class="navbar-header  d-flex flex-row-reverse ml-auto" style="padding-bottom: 2px;">
      <button class="navbar-toggler btn btn-lg btn-icon-only" type="button" data-toggle="collapse" aria-expanded="false" aria-label="Toggle navigation" style="border-color: black;" (click)="openGlobalNav()">
        <span class="oi oi-menu"></span>
      </button>
      <app-expense-quick-add-button *ngIf="showQuickAdd()" [buttonType]="'mobile-nav'" [userKeyID]="employeeInfo.UserKeyID" (lastInvalidsChange)="onLastInvalidsChange($event)"></app-expense-quick-add-button>
      <div class="nav-item dropdown" *ngIf="showTeamLinkOnNav()">
        <button class="navbar-toggler btn btn-lg btn-icon-only" style="color: black; margin-right: 15px; border-color: black;" type="button" data-toggle="dropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span class="oi oi-grid-three-up"></span>
        </button>
        <div class="dropdown-menu" style="left: auto; right: 0">
          <ul class="col-md-12" style="margin-bottom: 0px;">
            <div class="multi-column-dropdown">
            <li>
              <a class="dropdown-item" [href]="viewpointOneUrl" style="font-size: 13px" [target]="_blank">Navigate to TC1 Homepage</a>
            </li>
            <li>
              <a class="dropdown-item" [href]="ViewpointAnalyticsURL()" style="font-size: 13px" [target]="_blank">TC1 Analytics</a>
            </li>
            <li>
              <a class="dropdown-item" (click)="navigateToNotifications()" style="font-size: 13px; cursor: pointer">View Recent Errors</a>
            </li>
        </div>
        </ul>
      </div>
    </div>

    <!--Bell Notifications-->
    <div class="nav-item dropdown">
      <app-bell-notification class="navbar-toggler navbar-notification" style="padding: 15px 8px;"></app-bell-notification>
    </div>
    <app-ai-chatbot class="ai-chatbot-mobile"></app-ai-chatbot>
  </div>

  <!-- Navigation for Web view -->
  <div class="collapse navbar-collapse">
    <ul class="navbar-nav ml-auto">
      <ng-container *ngFor="let module of moduleCategories;let moduleIndex = index" class="dropdown">
        <li class="nav-item dropdown">
          <a *ngIf="module.barName === 'Office Tools'" class="nav-link" href="/Office/Index" style="font-size: 15px;" aria-haspopup="true" aria-expanded="false">Office Tools</a>
          <a *ngIf="module.barName !== 'Office Tools'" href="#" data-toggle="dropdown" class="nav-link" style="font-size: 15px;" aria-haspopup="true" aria-expanded="false">
            {{module.barName}}
            <span class="badge badge-pill badge-danger" *ngIf="module.barName == 'Approval' && unapprovedRequestCount > 0">{{unapprovedRequestCount}}</span>
            <span class="badge badge-pill badge-danger" *ngIf="module.barName === 'Approval' && unapprovedRequestCount == 0 && flagsExist"><span class="oi oi-flag"></span></span>
            <span class="badge badge-pill badge-danger" *ngIf='module.barName == "Field Tools" && fieldToolsCount > 0'>{{fieldToolsCount}}</span>
            <span class="badge badge-pill badge-danger" *ngIf='showCCTransactionCount() && module.barName == "Employee Tools" && unReconciledLinesCount > 0'>{{unReconciledLinesCount}}</span>
          </a>
          <div class="dropdown-menu nav-dropdown-menu" *ngIf="(moduleIndex == 0 || moduleIndex == 1) && module.barName != 'Field Tools'"
               [ngClass]="{columns3: (module.groupCount > 2 && module.catID != 1) || (module.groupCount > 1 && module.catID == 1), columns2: (module.groupCount > 1 && module.catID != 1) || (module.groupCount < 2 && module.groupCount != 0 && module.catID == 1), columns1: module.groupCount == 0, removeUlTBPadding: module.catID == 1, rightDisplay : moduleCategories?.length > 3, leftDisplay : moduleCategories?.length <=3}">
            <div [ngClass]="{'row-eq-height': module.catID == 1 && module.groupCount != 0}">
              <div *ngFor="let group of module.list; let groupIndex = index" [ngClass]="{row: groupIndex % 3 == 2}">
                <div *ngIf="group.catID != 1" [ngClass]="{'col-md-4': module.groupCount > 2, 'col-md-6': module.groupCount == 2, 'col-md-12': module.groupCount == 1}">
                  <ul class="multi-column-dropdown" style="margin-bottom:10px;">
                    <span class="dropdown-header nav-dropdown-header" style="font-size: 11px;">{{subStringFromComma(group.catName)}}</span>
                    <li *ngFor="let data of group.items">
                      <ng-container *ngIf="data.ModuleShowInNav && module.barName == 'Field Service'">
                        <a class="dropdown-item" href="{{data.ModuleActionName_Route}}" [fragment]="data.ModuleActionName_Fragment" [target]="data.ModuleOpenNewWindow ? '_blank' : '_self'" *ngIf="data.IsNewAngular && data.ModuleName != 'TrimblePay' && data.ModuleName != 'ServiceHub'">
                          <span style="font-size: 13px;">{{data.ModulePrettyShortName}}</span>
                        </a>
                        <a class="dropdown-item moduleLink" *ngIf="data.ModuleName === 'ServiceHub'"
                           (click)="openServiceHubLink()">
                          Service Hub
                        </a>
                      </ng-container>
                      <ng-container *ngIf="data.ModuleShowInNav && module.barName != 'Field Service'">
                        <a class="dropdown-item" routerLink="{{data.ModuleActionName_Route}}" [fragment]="data.ModuleActionName_Fragment" [target]="data.ModuleOpenNewWindow ? '_blank' : '_self'" *ngIf="data.IsNewAngular && data.ModuleName != 'TrimblePay' && data.ModuleName != 'ServiceHub'">
                          <span class="badge badge-pill"
                                [ngClass]="approvalCounts[data.ApprovalType] == 0 ? 'badge-success' : 'badge-danger'"
                                *ngIf="data.ApprovalType && data.ApprovalType != 'IssueTracker' && data.ApprovalType != 'ExpenseSubmit' && approvalCounts[data.ApprovalType] >= 0">{{approvalCounts[data.ApprovalType]}}</span>
                          <span class="badge badge-pill badge-danger" *ngIf="data.ApprovalType && approvalCounts[data.ApprovalType] < 0"><span class="oi oi-flag"></span></span>

                          <span style="font-size: 13px;">{{data.ModulePrettyShortName}}</span>
                          <span class="badge badge-pill"
                                [ngClass]="fieldToolsCount == 0 ? 'badge-success' : 'badge-danger'"
                                *ngIf="data.ApprovalType == 'IssueTracker' && fieldToolsCount != null">{{fieldToolsCount}}</span>

                          <span class="badge badge-pill badge-danger" *ngIf="data.ModuleActionName == userAccess && isOver()"><span class="oi oi-flag"></span></span>
                        </a>
                        <a class="dropdown-item" style="font-size: 13px;cursor:pointer;line-height:2;" *ngIf="data.ModuleName == 'TrimblePay'"
                           (click)="openPayLink()">
                          Trimble Pay
                        </a>
                      </ng-container>
                    </li>
                  </ul>
                </div>
              </div>
              <div *ngFor="let group of module.list;let groupIndex = index" [ngClass]="{ leftSideStyle: group.catName == 'My Tools', rightSideStyle: group.catName == 'Management'}">
                <div *ngIf="group.catID == 1" class="col-md-12">
                  <ul class="multi-column-dropdown">
                    <span class="dropdown-header nav-dropdown-header" style="color: black; font-weight: bold;">{{group.catName}}</span>
                    <div [ngClass]="{row: groupIndex % 2 == 1 && group.catName == 'Management' }">
                      <div *ngFor="let item of group.items | keyvalue" [ngClass]="{'col-md-6': group.catName == 'Management' && module.groupCount > 1, 'col-md-12': group.catName == 'My Tools' || group.catName == 'Management' && module.groupCount == 1}">
                    <li>
                      <span class="dropdown-header nav-dropdown-header" style="font-size: 11px;">
                        {{subStringFromComma(item.key)}}
                      </span>
                      <div *ngFor="let data of item.value">
                        <ul class="multi-column-dropdown">
                          <li *ngIf="data.ModuleShowInNav">
                            <a class="dropdown-item" routerLink="{{data.ModuleActionName_Route}}" [fragment]="data.ModuleActionName_Fragment" [target]="data.ModuleOpenNewWindow ? '_blank' : null" *ngIf="data.IsNewAngular && data.ModuleName != 'TrimblePay' && data.ModuleName != 'ServiceHub'">
                              <span style="font-size: 13px;">{{data.ModulePrettyShortName}}</span>
                              <span class="badge badge-pill"
                                    [ngClass]="unReconciledLinesCount == 0 ? 'badge-success' : 'badge-danger'"
                                    *ngIf="showCCTransactionCount() && data.ApprovalType == 'ExpenseSubmit' && unReconciledLinesCount != null">{{unReconciledLinesCount}}</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </li>
                </div>
              </div>
    </ul>
  </div>
  </div>
  </div>
  </div>

  <div class="dropdown-menu nav-dropdown-menu" [ngClass]="{columns3: module.list.length > 2, columns2: module.list.length > 1}" *ngIf="(moduleIndex > 1) || module.barName == 'Field Tools'" style="left:auto;right:0">
    <div class="d-flex" style="flex-flow:wrap;">
      <div *ngFor="let group of module.list; let group2Index = index" [ngStyle]="{'flex-grow': (group2Index == 0) ? 0.8 : 1}" style="display: contents;">
        <div [ngClass]="{'col-md-4': module.list.length > 2, 'col-md-6': module.list.length == 2, 'col-md-12': module.list.length == 1}">
          <ul class="multi-column-dropdown" style="margin-bottom:10px;">
            <span class="dropdown-header nav-dropdown-header" style="font-size: 11px;">{{subStringFromComma(group.catName)}}</span>
            <li *ngFor="let data of group.items">
              <ng-container *ngIf="data.ModuleShowInNav && module.barName == 'Field Service'">
                <a class="dropdown-item" href="{{data.ModuleActionName_Route}}" [fragment]="data.ModuleActionName_Fragment" [target]="data.ModuleOpenNewWindow ? '_blank' : '_self'" *ngIf="data.IsNewAngular && data.ModuleName !== 'TrimblePay' && data.ModuleName !== 'ClockInKiosk' && data.ModuleName !== 'ServiceHub'">
                  <span style="font-size: 13px;">{{data.ModulePrettyShortName}}</span>
                </a>
                <a class="dropdown-item moduleLink" *ngIf="data.ModuleName === 'ServiceHub'" (click)="openServiceHubLink()">
                  Service Hub
                </a>
              </ng-container>
              <ng-container *ngIf="data.ModuleShowInNav && module.barName != 'Field Service'">
                <a class="dropdown-item" routerLink="{{data.ModuleActionName_Route}}" [fragment]="data.ModuleActionName_Fragment" [target]="data.ModuleOpenNewWindow ? '_blank' : '_self'" *ngIf="data.IsNewAngular && data.ModuleName != 'TrimblePay' && data.ModuleName != 'ServiceHub' && data.ModuleName != 'ClockInKiosk'">
                  <span style="font-size: 13px;">{{data.ModulePrettyShortName}}</span>
                  <span class="badge badge-pill"
                        [ngClass]="approvalCounts[data.ApprovalType] == 0 ? 'badge-success' : 'badge-danger'"
                        *ngIf="data.ApprovalType && data.ApprovalType != 'IssueTracker' && data.ApprovalType != 'ExpenseSubmit' && approvalCounts[data.ApprovalType] >= 0">{{approvalCounts[data.ApprovalType]}}</span>
                  <span class="badge badge-pill badge-danger" *ngIf="data.ApprovalType && approvalCounts[data.ApprovalType] < 0"><span class="oi oi-flag"></span></span>

                  <span class="badge badge-pill"
                        [ngClass]="fieldToolsCount == 0 ? 'badge-success' : 'badge-danger'"
                        *ngIf="data.ApprovalType == 'IssueTracker' && fieldToolsCount != null">{{fieldToolsCount}}</span>

                  <span class="badge badge-pill badge-danger" *ngIf="data.ModuleActionName == userAccess && isOver()"><span class="oi oi-flag"></span></span>
                </a>
                <a class="dropdown-item" *ngIf="data.IsNewAngular && data.ModuleName == 'ClockInKiosk'" [href]="" [target]="data.ModuleOpenNewWindow ? '_blank' : '_self'" (click)="onKioskClicked($event,data.ModuleActionName)" style="cursor: pointer;">
                  <span style="font-size: 13px;">{{data.ModulePrettyShortName}}</span>
                </a>
                <a class="dropdown-item moduleLink" *ngIf="data.ModuleName === 'TrimblePay'" (click)="openPayLink()">
                  Trimble Pay
                </a>
              </ng-container>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  </li>
  </ng-container>
  <li class="nav-item dropdown" *ngIf="hotlistItems.length == 0">
    <a href="#" data-toggle="dropdown" class="nav-link dropdown" style="font-size: 15px;">
      Hotlist
    </a>
    <div class="dropdown-menu nav-dropdown-menu" style="font-size: 13px; left: auto; right: 0">
      <ul class="col-md-12" style="margin-bottom:10px;">
        <div class="multi-column-dropdown">
        <li>
          <a class="dropdown-item" style="padding-left: 15px;">No Hotlist Items Selected</a>
        </li>
    </div>
    </ul>
    </div>
  </li>
  <li class="nav-item dropdown" *ngIf="hotlistItems.length > 0">
    <a href="#" data-toggle="dropdown" class="nav-link" style="font-size: 15px;">
      Hotlist
    </a>
    <div class="dropdown-menu nav-dropdown-menu" style="left:auto;right:0">
      <ul class="col-md-12" [ngStyle]="{'margin-bottom': (hotlistItems.length == 1) ? '0px' : '10px'}">
        <div class="multi-column-dropdown">
        <li>
          <div *ngFor="let hotlistItem of hotlistItems">
            <a class="dropdown-item" style="font-size: 13px;" routerLink="{{hotlistItem.ModuleActionName_Route}}" [fragment]="hotlistItem.ModuleActionName_Fragment" [target]="hotlistItem.ModuleOpenNewWindow ? '_blank' : null" *ngIf="hotlistItem.IsNewAngular && hotlistItem.ModuleName != 'ClockInKiosk' && hotlistItem.ModuleName != 'ServiceHub'">{{hotlistItem.ModulePrettyShortName}}</a>
            <a class="dropdown-item" style="font-size: 13px;" href="{{hotlistItem.ModuleActionName}}" [target]="hotlistItem.ModuleOpenNewWindow ? '_blank' : '_self'" *ngIf="!hotlistItem.IsNewAngular">{{hotlistItem.ModulePrettyShortName}}</a>
            <a class="dropdown-item" *ngIf="hotlistItem.IsNewAngular && hotlistItem.ModuleName == 'ClockInKiosk'" style="font-size: 13px; cursor: pointer;" [href]="" [target]="hotlistItem.ModuleOpenNewWindow ? '_blank' : '_self'" (click)="onKioskClicked($event,hotlistItem.ModuleActionName)">
              {{hotlistItem.ModulePrettyShortName}}
            </a>
            <a class="dropdown-item" *ngIf="hotlistItem.ModuleName == 'ServiceHub'" style="font-size: 13px; cursor: pointer;" [href]="" [target]="hotlistItem.ModuleOpenNewWindow ? '_blank' : '_self'" (click)="openServiceHubLink()">
              {{hotlistItem.ModulePrettyShortName}}
            </a>
          </div>
        </li>
    </div>
    </ul>
    </div>
  </li>

  <!--Bell Notifications-->
  <div class="nav-item dropdown">
    <app-bell-notification class="nav-link"></app-bell-notification>
  </div>
  <app-ai-chatbot class="ai-chatbot-desktop"></app-ai-chatbot>
  <li class="nav-item dropdown" *ngIf="showTeamLinkOnNav()" style="max-height: 50px; ">
    <a class="nav-link" href="#" data-toggle="dropdown">
      <span class="oi oi-grid-three-up"></span>
    </a>
    <div class="dropdown-menu nav-dropdown-menu" style="left: auto; right: 0">
      <ul class="col-md-12">
        <div class="multi-column-dropdown">
        <li>
          <a class="dropdown-item" [href]="viewpointOneUrl" style="font-size: 13px" [target]="_blank">Navigate to TC1 Homepage</a>
        </li>
        <li>
          <a class="dropdown-item" [href]="ViewpointAnalyticsURL()" style="font-size: 13px" [target]="_blank">TC1 Analytics</a>
        </li>
        <li>
          <a routerLink="/home/notifications" class="dropdown-item" style="font-size: 13px">View Recent Errors</a>
        </li>
    </div>
    </ul>
    </div>
  </li>
  <li class="nav-item dropdown">
    <a href="#" data-toggle="dropdown" class="nav-link dropdown" style="font-size: 15px;">
      <span class="oi oi-person" style="margin-right: 5px;"></span>
      <span>{{employeeName}}</span>
    </a>
    <div class="dropdown-menu nav-dropdown-menu" style="left: auto; right: 0">
      <ul class="col-md-12" style="margin-bottom:10px;">
        <div class="multi-column-dropdown">
        <li *ngIf="vpUserName != null">
          <strong style="display: inline;margin-left:15px;font-size:0.8em;color:grey;margin-right:5px;">VP Username: </strong><span style="font-size: 0.8em; color: grey; margin-left: 15px;">{{vpUserName}}</span>
        </li>
        <li>
          <strong style="display: inline;margin-left:15px;font-size:0.8em;color:grey;margin-right:5px;">PRCo: </strong><span style="font-size: 0.8em;color: grey;">{{prco}}</span>
          <strong style="display: inline;margin-left:15px;font-size:0.8em;color:grey;margin-right:5px;">Employee: </strong><span style="font-size: 0.8em;color: grey;">{{employee}}</span>
          <div *ngIf="viewpointOneUserID || trimbleID()">
            <span *ngIf="tidEnabled() && trimbleID()" id="vpName" style="background-color:#0e416c;margin-left:15px;margin-top: -1px;">TID Linked</span>
            <a *ngIf="tidEnabled() && trimbleID()" id="TIDProfile" class="ml-1" href="https://myprofile.trimble.com/" target="_blank">TID Profile</a>
            <span *ngIf="!tidEnabled() && viewpointOneUserID" id="vpName" style="background-color:#0e416c;margin-left:15px;margin-top: -1px;">VPID Linked</span>
          </div>
        </li>
        <li class="dropdown-divider"></li>
        <li *ngIf="helpLink() !== null && helpLink() !== ''"><a class="dropdown-item" target="_blank" [href]="helpLink()" style="font-size: 13px">Help</a></li>
        <li><a class="dropdown-item" href="mailto:{{feedbackEmail()}}?subject=Employee Portal Feedback" style="font-size: 13px">Feedback?</a></li>
        <li *ngIf="showPaperless()"><a href="#" class="dropdown-item" (click)="paperLessModal()" style="font-size: 13px">Manage Paperless Setting</a></li>
        <li *ngIf="showChangePassword()"><a class="dropdown-item" [routerLink]="'/account/changeaccountpassword'" [queryParams]="{}" style="font-size: 13px; cursor: pointer">{{changePasswordLabel()}}</a></li>
        <li *ngIf="suggestionUrl !== null">
          <a class="dropdown-item" [href]="suggestionUrl" target="_blank" style="font-size: 13px">Suggestion Box <img id="discussion" src="/Cache/images/Discussions.png" alt="" style="margin-left: 5px;" /></a>
        </li>
        <li *ngIf="mobileInitUrl !== null"><a class="dropdown-item" [href]="this.mobileInitUrl  | dOMSafe:'url'" style="font-size: 13px">Initialize Mobile App</a></li>
        <app-navbar-clock-in *ngIf="navBarClockInEnabled()"></app-navbar-clock-in>

        <li class="dropdown-divider"></li>
        <li><a class="dropdown-item" style="font-size: 13px; cursor: pointer" (click)="logout()">Logout</a></li>
    </div>
    </ul>
    </div>
  </li>

  </ul>
  </div>
  </div>
</nav>